async function getCurrentPosition(required?: boolean): Promise<{lat: number, lng: number, accuracy: number} | undefined> {
    return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve({lat: position.coords.latitude, lng: position.coords.longitude, accuracy: position.coords.accuracy})
                },
                (err) => {
                    if (required) {
                        reject(err)
                    } else {
                        resolve(undefined)
                    }
                },
                {
                    enableHighAccuracy: true,
                    timeout: required ? Infinity : 5000
                }
            )
        } else {
            if (required) {
                reject(new Error('Dit apparaat ondersteund geen locatie'))
            } else {
                resolve(undefined)
            }
        }
    })
}

function watchPosition(callback?: (err: string | null, position?: {lat: number, lng: number, accuracy: number, heading: number}) => void) {
    if (navigator.geolocation) {
        return navigator.geolocation.watchPosition(
            (position) => {
                if (typeof callback === 'function') {
                    callback(null, {lat: position.coords.latitude, lng: position.coords.longitude, accuracy: position.coords.accuracy, heading: position.coords.heading})
                }
            },
            (err) => {
                if (typeof callback === 'function') {
                    callback(err.message)
                }
            },
            {
                enableHighAccuracy: true,
                timeout: 50000,
                maximumAge: 10000
            }
        )
    } else {
        if (typeof callback === 'function') {
            callback('Dit apparaat ondersteund geen locatie')
        }
    }
}

function clearWatch(id: number) {
    if (navigator.geolocation) {
        navigator.geolocation.clearWatch(id)
    }
}

async function checkPermissions() {
    if (navigator?.permissions?.query) {
        const result = await navigator.permissions.query({name: 'geolocation'})

        if (result.state === 'granted') {
            return
        } else if (result.state === 'prompt') {
            try {
                await getCurrentPosition()
            } catch {
                throw new Error('Toegang tot locatie is uitgeschakeld, druk op Help voor instructies om toegang tot locatie toe te staan.')
            }
        } else {
            throw new Error('Toegang tot locatie is uitgeschakeld, druk op Help voor instructies om toegang tot locatie toe te staan.')
        }
    } else {
        try {
            await getCurrentPosition()
        } catch {
            throw new Error('Toegang tot locatie is uitgeschakeld, druk op Help voor instructies om toegang tot locatie toe te staan.')
        }
    }
}

export default {
    getCurrentPosition,
    watchPosition,
    clearWatch,
    checkPermissions
}
